import { writable } from 'svelte/store';

let siteText            = 'Freire Imóveis';
let siteDescription     = 'Imobiliária - Porto Alegre - RS';

export let tagsSEO      = writable('');

export const alt				= writable(siteText);
export const headerTitleHome	= writable(siteText + " | " + siteDescription);
export const headerTitle		= writable("| " + siteText);
export const textSite			= writable(siteText);

export const ntRent			= writable('1');
export const ntSeason		= writable('0');
export const ntSell			= writable('8');

// E-mails
export const mailAtendimento	= writable("siteatendimento@freireimoveis.com.br");
export const mailLocacao		= writable("sitelocacao@freireimoveis.com.br");
export const mailVendas			= writable("sitevendas@freireimoveis.com.br");
export const mailOuvidoria		= writable("siteouvidoria@freireimoveis.com.br");
export const mailRH				= writable("siterh@freireimoveis.com.br");
export const mailLista			= writable("sitelista@freireimoveis.com.br");
export const mailAtualize		= writable("siteatendimento@freireimoveis.com.br");
export const mailCadastro		= writable("siteatendimento@freireimoveis.com.br");
export const mailLoteamentos	= writable("siteloteamento@freireimoveis.com.br");
export const mailCondominios	= writable("sitecondominios@freireimoveis.com.br");
export const mailProposta		= writable("siteproposta@freireimoveis.com.br");
export const mailComercial		= writable("sitecomercial@freireimoveis.com.br");
export const mailSeguros		= writable("atendimento@rfsseguros.com.br");

export const textTelefoneVendas		= writable("(51) 3396-4488");
export const linkTelefoneVendas		= writable("tel://5133964488");

export const textTelefoneLocacao	= writable("(51) 3396-4455");
export const linkTelefoneLocacao	= writable("tel://5133964455");

export const textTelefoneCondominio	= writable("(51) 3396-4477");
export const linkTelefoneCondominio	= writable("tel://5133964477");

export const textTelefoneOrcamento	= writable("(51) 3396-4490");
export const linkTelefoneOrcamento	= writable("tel://5133964490");

export const textTelefoneCobranca	= writable("(51) 3396-4480");
export const linkTelefoneCobranca	= writable("tel://5133964480");

export const textTelefoneDepPessoal	= writable("(51) 3396-4470");
export const linkTelefoneDepPessoal	= writable("tel://5133964470");

export const textTelefoneManutencao	= writable("(51) 3396-4450");
export const linkTelefoneManutencao	= writable("tel://5133964450");

export const textTelefoneContasPga	= writable("(51) 3396-4456");
export const linkTelefoneContasPga	= writable("tel://5133964456");

export const todosContatos = writable([
	{
		title: 'Vendas',
		icon: '<i class="fas fa-phone-square-alt"></i> (51) 3396-4488',
		href: 'tel://5133964488',
		target: '_blank',
		phone: '(51) 3396-4488',
		email: 'vendas@freireimoveis.com.br'
	},
	{
		title: 'Locações',
		icon: '<i class="fas fa-phone-square-alt"></i> (51) 3396-4455',
		href: 'tel://5133964455',
		target: '_blank',
		phone: '(51) 3396-4455',
		email: 'locacao@freireimoveis.com.br'
	},
	{
		title: 'Condomínios',
		icon: '<i class="fas fa-phone-square-alt"></i> (51) 3396-4477',
		href: 'tel://5133964477',
		target: '_blank',
		phone: '(51) 3396-4477',
		email: 'condominio@freireimoveis.com.br'
	},
	{
		title: 'Orçamentos',
		icon: '<i class="fas fa-phone-square-alt"></i> (51) 3396-4490',
		href: 'tel://5133964490',
		target: '_blank',
		phone: '(51) 3396-4490',
		email: 'orcamento@freireimoveis.com.br'
	},
	{
		title: 'Cobrança',
		icon: '<i class="fas fa-phone-square-alt"></i> (51) 3396-4480',
		href: 'tel://5133964480',
		target: '_blank',
		phone: '(51) 3396-4480',
		email: 'cobranca@freireimoveis.com.br'
	},
	{
		title: 'Dep.Pessoal',
		icon: '<i class="fas fa-phone-square-alt"></i> (51) 3396-4470',
		href: 'tel://5133964470',
		target: '_blank',
		phone: '(51) 3396-4470',
		email: 'pessoal@freireimoveis.com.br'
	},
	{
		title: 'Manutenção',
		icon: '<i class="fas fa-phone-square-alt"></i> (51) 3396-4450',
		href: 'tel://5133964450',
		target: '_blank',
		phone: '(51) 3396-4450',
		email: 'manutencao@freireimoveis.com.br'
	},
	{
		title: 'Contas a pagar',
		icon: '<i class="fas fa-phone-square-alt"></i> (51) 3396-4456',
		href: 'tel://5133964456',
		target: '_blank',
		phone: '(51) 3396-4456',
		email: 'contasapagar@freireimoveis.com.br'
	},
]);

export const whatsappComercial		= writable("5551993194659");
export const textWhatsappComercial	= writable("(51) 99319-4659");
export const linkWhatsappComercial	= writable("https://wa.me/5551993194659");

export const whatsappVendas			= writable("5551999795405");
export const textWhatsappVendas		= writable("(51) 99979-5405");
export const linkWhatsappVendas		= writable("https://wa.me/5551999795405");

export const whatsappLocacao		= writable("555133964477");
export const textWhatsappLocacao	= writable("(51) 3396-4477");
export const linkWhatsappLocacao	= writable("https://wa.me/555133964477");

export const whatsappCondominio		= writable("555133964477");
export const textWhatsappCondominio	= writable("(51) 3396-4477");
export const linkWhatsappCondominio	= writable("https://wa.me/555133964477");

// Links
export const linkPesquisaVendas		= writable("/imoveis/vendas#tipo_negociacao=8");
export const linkPesquisaLocacao	= writable("/imoveis/locacao#tipo_negociacao=1");

// Redes Sociais e Atendimento
export const linkFacebook       = writable("https://www.facebook.com/FreireImoveis");
export const linkInstagram      = writable("https://www.instagram.com/FreireImoveis/");
export const linkYoutube        = writable("");
export const linkTwitter        = writable("https://twitter.com/freireimoveis");
export const linkBlog	        = writable("https://blog.freireimoveis.com.br/");

export const linkMapa           = writable("https://goo.gl/maps/2HWrSVm2v29oaDZX8");
export const linkWaze           = writable("https://waze.com/ul?ll=-30.045418,-51.223890&navigate=yes");
export const linkUber           = writable("https://m.uber.com/ul/?action=setPickup&client_id=9zzPwceWa0hEu1fLOgKkUoEp0EmIVgjH&pickup=my_location&dropoff[formatted_address]=Rua%20M%C3%BAcio%20Teixeira%2C%20129%2C%20Menino%20Deus%2C%20Porto%20Alegre%20-%20RS");
export const linkIframeMapa     = writable("https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3453.6928494951567!2d-51.22608918429432!3d-30.045668538295313!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x951978f8e10f1c57%3A0x3d1bc63c28f72f4c!2sFreire%20Im%C3%B3veis!5e0!3m2!1spt-BR!2sbr!4v1651598914302!5m2!1spt-BR!2sbr");

export const linkAPI            = writable("http://www.api.com.br");
export const linkAV             = writable("https://freireimoveis.com.br/freireonline/");
export const linkConheca        = writable("https://freireimoveis.com.br/SiteAV/");
export const linkBoletoFacil    = writable("https://www.freireimoveis.com.br/freireonline/login?boleto-facil=1");

export const linkManualSindico  = writable("/assets/files/Guia_de_Orientacao_do_Sindico_202304.pdf");

export const textAtendimento            = writable("De Segunda a Sexta-Feira, das 09h às 17h.");
export const textEndereco               = writable("Rua Múcio Teixeira, 129, Menino Deus, Porto Alegre - RS");
export const textCNPJ                   = writable("11.970.722/0001-95");
export const textCreci                  = writable("20409J");

export const linkPoliticaPrivacidade	= writable("/assets/files/PoliticaDePrivacidadeDeSite_FreireImoveis.pdf");
export const linkPoliticaCookies		= writable("/assets/files/PoliticaDeCookies_FreireImoveis.pdf");
export const linkTermoLGPD				= writable("/assets/files/TermoLGPD.pdf");

export const textPoliticaCheck 			= writable("Aceito compartilhar meus dados de acordo com a <a href='/assets/files/PoliticaDePrivacidadeDeSite_FreireImoveis.pdf' target='_blank'>Política de Privacidade</a> e com a <a href='/assets/files/PoliticaDeCookies_FreireImoveis.pdf' target='_blank'>Política de Cookies</a> da Freire Imóveis. Estou ciente e concordo em receber todas as comunicações relativas ao meu cadastro, incluindo comunicados, informações e promoções.");
